import {z} from "zod/v4-mini"

export type Space = "TANGENT" | "OBJECT" | "WORLD" | "BLENDER_OBJECT" | "BLENDER_WORLD"
export const spaceSchema = z.enum(["TANGENT", "OBJECT", "WORLD", "BLENDER_OBJECT", "BLENDER_WORLD"])
export type CyclesSpaceType = "tangent" | "object" | "world" | "blender_object" | "blender_world"
export const cyclesSpace = (space?: Space): CyclesSpaceType | undefined => {
    if (!space) {
        return undefined
    }

    switch (space) {
        case "TANGENT":
            return "tangent"
        case "OBJECT":
            return "object"
        case "WORLD":
            return "world"
        case "BLENDER_OBJECT":
            return "blender_object"
        case "BLENDER_WORLD":
            return "blender_world"
        default:
            throw new Error(`Unknown space type: ${space}`)
    }
}
